module.exports = __webpack_public_path__ + "static/media/Anna.Fiedorowicz.2025-778x1024-removebg-preview.2c550403.png";